import PropTypes from 'prop-types';
import { Link, Stack, Typography } from '@mui/material';
import UTurnLeftIcon from '@mui/icons-material/UTurnLeft';
import { useNavigate } from 'react-router-dom';

// NotFound, InternalServerError画面の中身
const Error = ({ message }) => {
  const navigate = useNavigate();
  return (
    <Stack textAlign='center' alignItems='center' padding='32px'>
      <Typography variant="head32bold" whiteSpace='pre-wrap'>
        {message}
      </Typography>
      <Stack direction='row' marginTop='24px'>
        <Link
          variant="body16bold" underline="hover"
          display='flex' alignItems='center'
          onClick={() => navigate(-1)} >
          <UTurnLeftIcon color="primary" sx={{ transform: 'rotate(90deg)', marginRight: '8px' }} />
          前のページへ戻る
        </Link>
      </Stack>
    </Stack>
  );
};

export default Error;

Error.propTypes = {
  message: PropTypes.string,
};
